import React from 'react';
import { Icon, IconProps } from '@chakra-ui/icon';
import { ReactComponent as Menu } from '@src/icons/mobile-menu-icon.svg';

export const MenuIcon: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 24 24" {...props} as={Menu} />
);
